import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "py-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", {
  class: "anchor fw-bolder mb-3",
  id: "icon-colors"
}, [
  /*#__PURE__*/_createVNode("a", { href: "#icon-colors" }),
  /*#__PURE__*/_createTextVNode(" Icon Colors ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" Use Font Awesome icons with spesific class as explained in the "),
  /*#__PURE__*/_createVNode("a", {
    class: "fw-bold",
    href: "https://fontawesome.com/icons/affiliatetheme?style=brands",
    target: "_blank"
  }, "Icon Preview Page"),
  /*#__PURE__*/_createTextVNode(": ")
], -1)
const _hoisted_4 = { class: "py-5" }
const _hoisted_5 = { class: "rounded border d-flex flex-wrap p-10" }
const _hoisted_6 = { class: "fw-bold py-2" }
const _hoisted_7 = { class: "py-5" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString(`<i class="las la-tint text-white"></i>
        <i class="las la-tint text-primary"></i>
        <i class="las la-tint text-secondary"></i>
        <i class="las la-tint text-light"></i>
        <i class="las la-tint text-success"></i>
        <i class="las la-tint text-info"></i>
        <i class="las la-tint text-warning"></i>
        <i class="las la-tint text-danger"></i>
        <i class="las la-tint text-dark"></i>
        <i class="las la-tint text-muted"></i>
        <i class="las la-tint text-gray-100"></i>
        <i class="las la-tint text-gray-200"></i>
        <i class="las la-tint text-gray-300"></i>
        <i class="las la-tint text-gray-400"></i>
        <i class="las la-tint text-gray-500"></i>
        <i class="las la-tint text-gray-600"></i>
        <i class="las la-tint text-gray-700"></i>
        <i class="las la-tint text-gray-800"></i>
        <i class="las la-tint text-gray-900"></i>`))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.colors, (item, i) => {
          return (_openBlock(), _createBlock("div", {
            key: i,
            class: "d-flex flex-column flex-center w-150px me-10 mb-5"
          }, [
            _createVNode("i", {
              class: [[`text-${item}`, item === 'white' && `bg-dark`], "las la-tint fs-2x"]
            }, null, 2),
            _createVNode("div", _hoisted_6, _toDisplayString(item), 1)
          ]))
        }), 128))
      ])
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      })
    ])
  ]))
}